import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

export function CTAButton({ 
  href, 
  children, 
  variant = 'primary', 
  size = 'default',
  className,
  external = false,
  ...props 
}) {
  const baseStyles = "inline-flex items-center justify-center font-medium transition-all duration-200 focus-visible:ring-2 focus-visible:ring-[#2E79FF] focus-visible:ring-offset-2 focus-visible:ring-offset-[#060608]";
  
  const variants = {
    primary: "bg-[#2E79FF] text-white hover:bg-[#4C8DFF] hover:shadow-[0_0_20px_rgba(46,121,255,0.3)]",
    secondary: "bg-white/5 border border-white/10 text-white hover:bg-white/10 hover:border-white/20",
    ghost: "text-[#A1A1AA] hover:text-white hover:bg-white/5"
  };
  
  const sizes = {
    sm: "px-4 py-2 text-sm rounded-md",
    default: "px-6 py-3 text-sm rounded-lg",
    lg: "px-8 py-4 text-base rounded-lg"
  };
  
  const styles = cn(baseStyles, variants[variant], sizes[size], className);
  
  if (external) {
    return (
      <a href={href} className={styles} {...props}>
        {children}
      </a>
    );
  }
  
  if (href?.startsWith('#')) {
    return (
      <a href={href} className={styles} {...props}>
        {children}
      </a>
    );
  }
  
  return (
    <Link to={href} className={styles} {...props}>
      {children}
    </Link>
  );
}

export default CTAButton;
